import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import authReducer from './slices/authSlice';
import facilitiesReducer from './slices/facilitiesSlice';
import workersReducer from './slices/workersSlice';
import alertsReducer from './slices/alertsSlice';
import realtimeReducer from './slices/realtimeSlice';
import { criticalAlertsApi } from './api/criticalAlertsApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    facilities: facilitiesReducer,
    workers: workersReducer,
    alerts: alertsReducer,
    realtime: realtimeReducer,
    // RTK Query (ADR-004): server-state cache for new features.
    [criticalAlertsApi.reducerPath]: criticalAlertsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['realtime/updateWorkerLocation', 'realtime/addAlert'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: ['realtime.lastUpdate', 'realtime.connectionStatus.lastConnected'],
      },
    }).concat(criticalAlertsApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
